import React from "react";
import { createPortal } from "react-dom";
import "./styles.css";
import { dashboard_yellow_thumb_like } from "../../../assets/images";

interface AFLSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  onNav?: () => void;
  title?: string;
  refNumber?: string;
}

const AFLSuccessModal: React.FC<AFLSuccessModalProps> = ({
  isOpen,
  onClose,
  message,
  onNav,
  title = "Success!",
  refNumber,
}) => {
  if (!isOpen) return null;

  const handleOk = () => {
    if (onNav) {
      onNav();
    } else {
      onClose();
    }
  };

  return createPortal(
    <div className="afl-modal-overlay">
      <div className="afl-modal-container scale-in">
        <div className="afl-modal-content">
          <div className="afl-success-icon-wrapper">
            <img
              src={dashboard_yellow_thumb_like}
              alt="Success"
              className="afl-success-icon"
            />
          </div>

          <h3 className="afl-success-title">{title}</h3>
          <div
            className="afl-modal-message"
            dangerouslySetInnerHTML={{ __html: message.replace(/\n/g, "<br/>") }}
          ></div>

          {refNumber && (
            <div className="afl-ref-container">
              <span className="afl-ref-label">Reference Number:</span>
              <span className="afl-ref-value">{refNumber}</span>
            </div>
          )}

          <div className="afl-modal-footer">
            <button className="afl-ok-btn" onClick={handleOk}>
              OK
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AFLSuccessModal;
